import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {METHOD_ANALYTICS_INCLUDE_ALL_SOURCES_MEDIUMS, METHOD_ANALYTICS_INCLUDE_SOURCE_MEDIUM_ON_CONDITION} from './Account';
import {GA4FiltersEditor, GA4_AVAILABLE_FIELDS} from './GA4FiltersEditor';

class AnalyticsAccountConfigurationClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectionMethod: this.props.selectionMethod || METHOD_ANALYTICS_INCLUDE_ALL_SOURCES_MEDIUMS,
        };

        this.handleSelectionMethodChange = this.handleSelectionMethodChange.bind(this);
        this.handleFiltersChange = this.handleFiltersChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectionMethod !== this.props.selectionMethod) {
            this.setState({
                selectionMethod: this.props.selectionMethod || METHOD_ANALYTICS_INCLUDE_ALL_SOURCES_MEDIUMS,
            });
        }
    }

    handleSelectionMethodChange(event) {
        const newMethod = event.target.value;
        this.setState({selectionMethod: newMethod});

        if (this.props && this.props.onItemsSelectionMethodChange) {
            try {
                this.props.onItemsSelectionMethodChange(newMethod);
            } catch (error) {
                console.error('Error calling onItemsSelectionMethodChange:', error);
            }
        }
    }

    handleFiltersChange(newFilters) {
        if (this.props && this.props.onFiltersChange) {
            this.props.onFiltersChange(newFilters);
        }
    }

    render() {
        const {t} = this.props;

        return [
            <div key="selection_method" className="form-row">
                <label>{t('analytics_account_config.selection_method_label')}</label>
                <select
                    onChange={this.handleSelectionMethodChange}
                    name="selectionMethod"
                    required="required"
                    value={this.state.selectionMethod}
                >
                    <option value={METHOD_ANALYTICS_INCLUDE_ALL_SOURCES_MEDIUMS}>
                        {t('analytics_account_config.include_all_traffic')}
                    </option>
                    <option value={METHOD_ANALYTICS_INCLUDE_SOURCE_MEDIUM_ON_CONDITION}>
                        {t('analytics_account_config.filter_by_source_and_medium')}
                    </option>
                </select>
            </div>,
            this.renderFiltersEditor(),
        ];
    }

    renderFiltersEditor() {
        if (this.state.selectionMethod !== METHOD_ANALYTICS_INCLUDE_SOURCE_MEDIUM_ON_CONDITION) {
            return null;
        }

        return (
            <div key="ga4_filters_editor" className="form-row">
                <GA4FiltersEditor
                    filters={this.props.ga4Filters || []}
                    availableFields={GA4_AVAILABLE_FIELDS}
                    onChange={this.handleFiltersChange}
                />
            </div>
        );
    }
}

export const AnalyticsAccountConfiguration = withTranslation()(AnalyticsAccountConfigurationClass);
export default AnalyticsAccountConfiguration;
